var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerDeletion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4957 9.63724L54.0116 48.6358C54.6763 49.7872 53.8454 51.2265 52.5158 51.2265H7.48414C6.15463 51.2265 5.32367 49.7872 5.98844 48.6358L28.5043 9.63723C29.169 8.48584 30.8309 8.48583 31.4957 9.63724ZM25.9062 8.13723C27.7257 4.98583 32.2743 4.98584 34.0938 8.13724L56.6096 47.1358C58.4291 50.2872 56.1548 54.2265 52.5158 54.2265H7.48414C3.84522 54.2265 1.5709 50.2872 3.39037 47.1358L25.9062 8.13723ZM31.5538 19.955H28.3772L28.9066 38.4852H30.9866L31.5538 19.955ZM28.5285 46.0486C28.9319 46.4268 29.4109 46.6159 29.9655 46.6159C30.5202 46.6159 30.9866 46.4268 31.3647 46.0486C31.7429 45.6452 31.932 45.1788 31.932 44.6494C31.932 44.0947 31.7429 43.6409 31.3647 43.288C30.9866 42.9098 30.5202 42.7207 29.9655 42.7207C29.3857 42.7207 28.9066 42.9098 28.5285 43.288C28.1503 43.6409 27.9612 44.0947 27.9612 44.6494C27.9612 45.1788 28.1503 45.6452 28.5285 46.0486Z",
    fill: "#516F90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerDeletion);
export default __webpack_public_path__ + "static/media/danger_deletion.54709b1c53f446bc0bdad8c1e532334c.svg";
export { ForwardRef as ReactComponent };